import React, { useState } from 'react';
import { restrictedVideoProps } from '../utils/restrictedVideo';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import './VideoPopup.css';

const VideoPopup = ({ show, handleClose, videos, handleDelete }) => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [showViewer, setShowViewer] = useState(false);
    const [videoError, setVideoError] = useState(false);

    const handleViewVideo = (video) => {
        setSelectedVideo(video);
        setShowViewer(true);
        setVideoError(false);
    };

    const closeViewer = () => {
        setShowViewer(false);
        setSelectedVideo(null);
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered className="video-popup-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Videos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {videos.length === 0 ? (
                        <div className="text-center py-4">
                            <p className="text-muted mb-0">No videos uploaded yet.</p>
                        </div>
                    ) : (
                        <ListGroup>
                            {videos.map(video => (
                                <ListGroup.Item key={video.dataId} className="d-flex justify-content-between align-items-center">
                                    <span>{video.key.replace('webdata/videos/', '')}</span>
                                    <div className="btn-group">
                                        <Button variant="primary" onClick={() => handleViewVideo(video)}>
                                            View
                                        </Button>
                                        <Button variant="danger" onClick={() => handleDelete(video.dataId, video.name)}>
                                            Delete
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Video Viewer Modal */}
            <Modal show={showViewer} onHide={closeViewer} centered size="lg" className="video-viewer-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedVideo ? selectedVideo.key.replace('webdata/videos/', '') : 'Video Viewer'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedVideo && (
                        <>
                            {videoError ? (
                                <div className="alert alert-danger">
                                    <h5>Video Playback Error</h5>
                                    <p>Unable to load the video. This could be due to:</p>
                                    <ul className="text-start">
                                        <li>Network connectivity issues</li>
                                        <li>Video file format not supported</li>
                                        <li>Video file corrupted or missing</li>
                                        <li>CORS policy restrictions</li>
                                    </ul>
                                    <p><strong>Video URL:</strong> <code>{selectedVideo.url}</code></p>
                                    <Button 
                                        variant="outline-primary" 
                                        size="sm" 
                                        onClick={() => window.open(selectedVideo.url, '_blank')}
                                    >
                                        Try opening in new tab
                                    </Button>
                                </div>
                            ) : (
                                <video
                                    controls
                                    {...restrictedVideoProps}
                                    preload="auto"
                                    autoPlay
                                    muted
                                    className="video-element"
                                    style={{ 
                                        width: '100%',
                                        height: '400px',
                                        backgroundColor: '#000',
                                        borderRadius: '8px'
                                    }}
                                    onError={(e) => {
                                        console.error('Video playback error:', e);
                                        console.error('Video URL:', selectedVideo.url);
                                        setVideoError(true);
                                    }}
                                >
                                    <source src={selectedVideo.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeViewer}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default VideoPopup; 